export default __webpack_public_path__ + "static/media/teamWorkshopsImage.230349e9.svg";